import { cn } from "@/lib/utils";

/**
 * Unified section eyebrow for the Quality Assurance offering pages and the Regulatory
 * Toxicology page: 24px accent line + 12px uppercase grey label, 8px above the title.
 * Reference: "How we support you" on Inspection Readiness Support.
 */
const SectionEyebrow = ({
  children,
  light,
  accent = "var(--qa-copy-accent)",
  className,
}: {
  children: React.ReactNode;
  light?: boolean;
  accent?: string;
  className?: string;
}) => (
  <div className={cn("flex items-center gap-3 mb-2", className)}>
    <span aria-hidden="true" className="w-6 h-[1.5px] shrink-0 rounded-full" style={{ backgroundColor: accent }} />
    <p
      className={cn(
        "text-xs font-medium uppercase tracking-wider",
        light ? "text-primary-foreground/70" : "text-qa-copy-body",
      )}
    >
      {children}
    </p>
  </div>
);

export default SectionEyebrow;

/** Title style shared with the reference section (Oxford Blue, semibold). */
export const UNIFIED_SECTION_TITLE = "text-xl sm:text-2xl font-semibold text-foreground";
